var DefaultSorter = {
    sort: function (a, b) {
        if (typeof a === 'boolean' && typeof b === 'boolean') {
            return compare(a, b);
        }

        if (Array.isArray(a) || Array.isArray(b)) {
            return 0;
        }

        if (DateTime.isValidDate(a) && DateTime.isValidDate(b)) {
            var dateA = DateTime.parseDate(a);
            var dateB = DateTime.parseDate(b);
            a = DateTime.toTimeStamp(dateA);
            b = DateTime.toTimeStamp(dateB);
        }

        if (DateTime.isValidDateTime(a) && DateTime.isValidDateTime(b)) {
            var dateA = DateTime.parseDateTime(a);
            var dateB = DateTime.parseDateTime(b);
            a = DateTime.toTimeStamp(dateA);
            b = DateTime.toTimeStamp(dateB);
        }

        if (isNumericValueComparison(a, b)) {
            //Bootstrap comparison reads unset editable values as undefined and sorts the columns incorrectly
            a = a || 0;
            b = b || 0;
        }


        return compare(a, b);

        function compare(a, b) {
            if (a > b) return 1;
            if (a < b) return -1;
            return 0;
        }

        function isNumericValueComparison(a, b) {
            if (typeof (a) == 'number' && typeof (b) == 'number') {
                return false; //no need for further processing, both values are numbers
            }
            var aIsNumeric = isNumericValue(a);
            var bIsNumeric = isNumericValue(b);
            return aIsNumeric || bIsNumeric;

            function isNumericValue(value) {
                if (isNaN(value)) {
                    return false;
                }

                if (typeof (value) == 'string') {
                    return isNaN(jsUtils.data.parseFloatFromCultureToInvariant(value));
                }

                return true;
            }
        }
    }
};

export default DefaultSorter;
globalThis.DefaultSorter = DefaultSorter;